import { render, staticRenderFns } from "./ListCarteiraCobranca.vue?vue&type=template&id=535db536"
import script from "./ListCarteiraCobranca.vue?vue&type=script&lang=js"
export * from "./ListCarteiraCobranca.vue?vue&type=script&lang=js"
import style0 from "./ListCarteiraCobranca.vue?vue&type=style&index=0&id=535db536&prod&lang=scss"
import style1 from "./ListCarteiraCobranca.vue?vue&type=style&index=1&id=535db536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports